// Users API for DIOS10
import apiClient from './client';
import { API_ENDPOINTS } from './config';

export const usersApi = {
    // Register new user
    register: async (userData) => {
  try {
            const response = await apiClient.post(API_ENDPOINTS.USERS.REGISTER, userData);
            return response;
  } catch (error) {
    throw error;
  }
    },

    // Get user by ID
    getById: async (id) => {
  try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.GET_BY_ID(id));
            return response;
  } catch (error) {
    throw error;
  }
    },

    // Get user by wallet address
    getByAddress: async (address) => {
  try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.GET_BY_ADDRESS(address));
            return response;
  } catch (error) {
    throw error;
  }
    },

    // Get user by username
    getByUsername: async (username) => {
  try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.GET_BY_USERNAME(username));
            return response;
  } catch (error) {
    throw error;
  }
    },

    // Check auth
    checkAuth: async () => {
  try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.CHECK_AUTH);
            return response;
  } catch (error) {
    throw error;
        }
  },

    // Update tutorial completion
    updateTutorialCompleted: async (userId, tutorialCompleted) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_TUTORIAL_COMPLETED(userId), {
                tutorialCompleted
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update language
    updateLanguage: async (userId, language) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_LANGUAGE(userId), {
                language
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update password
    updatePassword: async (userId, currentPassword, newPassword, confirmNewPassword) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_PASSWORD(userId), {
                currentPassword,
                newPassword,
                confirmNewPassword
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update wallet address
    updateWallet: async (userId, walletAddress) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_WALLET(userId), {
                walletAddress
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update Skrill email
    updateSkrillEmail: async (userId, skrillEmail) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_SKRILL_EMAIL(userId), {
                skrillEmail
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update Wise email
    updateWiseEmail: async (userId, wiseEmail) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_WISE_EMAIL(userId), {
                wiseEmail
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Update gallery public/private setting
    updateGalleryPublic: async (userId, galleryPublic) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.UPDATE_GALLERY_PUBLIC(userId), {
                galleryPublic
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get login history
    getLoginHistory: async (userId, limit = 50, offset = 0) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.LOGIN_HISTORY(userId), {
                params: { limit, offset }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Create security report
    createSecurityReport: async (reportData) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.USERS.SECURITY_REPORT, reportData);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get user security reports
    getSecurityReports: async (userId, limit = 50, offset = 0) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.SECURITY_REPORTS(userId), {
                params: { limit, offset }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Request password reset
    requestPasswordReset: async (email) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.USERS.PASSWORD_RESET_REQUEST, { email });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Reset password with token
    resetPassword: async (token, newPassword) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.USERS.PASSWORD_RESET_RESET, {
                token,
                newPassword
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get active announcements
    getAnnouncements: async () => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.ANNOUNCEMENTS);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get activity report
    getActivityReport: async (userId, days = 7) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.ACTIVITY_REPORT(userId), {
                params: { days }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get user notifications
    getNotifications: async (userId, unreadOnly = false, limit = 50, offset = 0) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.NOTIFICATIONS(userId), {
                params: { unreadOnly, limit, offset }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Mark notification as read
    markNotificationAsRead: async (userId, notificationId) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.MARK_NOTIFICATION_READ(userId, notificationId));
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Mark all notifications as read
    markAllNotificationsAsRead: async (userId) => {
        try {
            const response = await apiClient.put(API_ENDPOINTS.USERS.MARK_ALL_NOTIFICATIONS_READ(userId));
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get active maintenance alerts
    getMaintenanceAlerts: async () => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.USERS.MAINTENANCE_ALERTS);
            return response;
        } catch (error) {
            throw error;
        }
    }
}; 

export default usersApi;
